import Link from "next/link";
import { MouseEventHandler, ReactNode } from "react";

const HexaLink = ({
  to,
  className,
  children,
  onOver,
  onOut,
}: HexaLinkProps) => {
  if (to.indexOf("http") === 0) {
    return (
      <a
        href={to}
        className={className}
        target="_blank"
        rel="noreferrer"
        onMouseOver={onOver}
        onMouseOut={onOut}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={to}
      className={className}
      onMouseOver={onOver}
      onMouseOut={onOut}
    >
      {children}
    </Link>
  );
};

interface HexaLinkProps {
  to: string;
  className?: string;
  children: ReactNode;
  onOver: MouseEventHandler<HTMLAnchorElement>;
  onOut: MouseEventHandler<HTMLAnchorElement>;
}

export default HexaLink;
